<template>
  <a-modal
    :visible="ShowPanel"
    :mask="false"
    width="50%"
    title="本地化渠道明细"
    @ok="addChannel"
    @cancel="handleCancel(true)"
  >
    <template slot="footer">
      <a-button key="back" @click="handleCancel(true)">
        取消
      </a-button>
      <a-button key="submit" type="primary" @click="addChannel()">
        新增
      </a-button>
    </template>
    <a-table
      :columns="tableColumns2"
      id="show-table2"
      style="flex: 1;overflow-y: hidden;background: #ffffff"
      :scroll="{ x: '500px', y: '500px' }"
      :data-source="ChannelList"
      :rowKey="item => item.id"
      :loading="loading"
      bordered
      :pagination="false"
    >
      <template slot="status" slot-scope="text, recode">
        <a-tag :color="recode.status == 1 ? '#87d068' : '#f50'">{{
          recode.status == 1 ? "开启中" : "已关闭"
        }}</a-tag>
      </template>
      <template slot="operation" slot-scope="text, recode">
        <a-button
          @click="switchStatusChange(recode)"
          :type="recode.status == 2 ? 'primary' : 'danger'"
          ghost
          >{{ recode.status == 2 ? "开启" : "关闭" }}</a-button
        >
      </template>
    </a-table>
    <a-modal
      :visible="addChannelStatus"
      :mask="false"
      width="40%"
      title="新增本地化渠道"
      @ok="doAddChannel()"
      @cancel="
        () => {
          addChannelStatus = false;
        }
      "
    >
      <a-form>
        <a-form-item
          label="渠道名称"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 17 }"
          help="请填写渠道全称"
        >
          <a-input v-model="addForm.name"></a-input>
        </a-form-item>
        <a-form-item
          label="渠道标识"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 17 }"
          help="全站唯一标识符，不可重复，最好为英文和数字，在GB显示"
        >
          <a-input v-model="addForm.channel"></a-input>
        </a-form-item>
        <a-form-item
          label="渠道描述"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 17 }"
        >
          <a-textarea v-model="addForm.desc"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      :visible="switchStatus"
      width="450px"
      title="更改渠道状态"
      @ok="changeStatus()"
      @cancel="switchStatus = false"
    >
    <div style="line-height: 32px;">
        是否将渠道名为 【{{ switchRecord.name }}】的状态</br>
          从 <a-tag :color="switchRecord.status == 1 ? '#87d068' : '#f50'">{{
          switchRecord.status == 1 ? "开启中" : "已关闭"
        }}</a-tag>  =>  <a-tag :color="switchRecord.status == 1 ? '#f50 ' : '#87d068'">{{
          switchRecord.status == 1 ? "已关闭" : "开启中"
        }}</a-tag>？
    </div>
    </a-modal>
  </a-modal>
</template>

<script>
import {
  AddSpendSelfChannel,
  StatusSpendSelfChannel
} from "../../../api/v1/spend_self_api";

export default {
  name: "ChannelPanel",
  props: ["ShowPanel", "ChannelList"],
  watch: {
    ChannelList(newVal, oldVal) {
        this.loading = false
    }
  },
  data() {
    return {
      tableColumns2: [
        { title: "渠道名称", dataIndex: "name", align: "center" },
        { title: "渠道标识", dataIndex: "channel", align: "center" },
        { title: "渠道描述", dataIndex: "desc", align: "center" },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
          align: "center"
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          align: "center"
        }
      ],
      addChannelStatus: false,
      addForm: {
        name: "",
        channel: "",
        desc: "",
        status: 1
      },
      loading: false,
      switchStatus: false,
      switchRecord: {
        channel: "",
        status: 0
      }
    };
  },
  mounted() {},
  methods: {
    addChannel() {
      this.addForm = {
        name: "",
        channel: "",
        desc: "",
        status: 1
      };
      this.addChannelStatus = true;
    },
    switchStatusChange(record) {
      this.switchRecord = record;
      this.switchStatus = true;
    },
    changeStatus() {
      StatusSpendSelfChannel({ channel: this.switchRecord.channel }).then(
        resp => {
          if (resp.code === 200) {
            this.$message.success(resp.msg);
            this.handleCancel();
          } else {
            this.$message.error(resp.msg);
          }
        }
      ).finally(() => {
        this.loading = true
        this.switchStatus = false
      });
    },
    handleCancel(isClose = false) {
      this.$emit("close-dialog", isClose);
    },
    doAddChannel() {
      AddSpendSelfChannel(this.addForm).then(resp => {
        if (resp.code === 200) {
          this.$message.success(resp.msg);
          this.addChannelStatus = false;
          this.$emit("close-dialog");
        } else {
          this.$message.error(resp.msg);
        }
      }).finally(() => {
        this.loading = true
      });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Spend/Self/ChannelPanel.vue